import { VFC } from "react";

interface Props {
  className?: string;
  tableClassName?: string;
  children?: JSX.Element | JSX.Element[];
}

const StyledTable: VFC<Props> = (props: Props) => {
  return (
    <div className={props.className || ""}>
      {/* horizontal scroll on narrow screens so table-fixed columns don't crush */}
      <div className="w-full overflow-x-auto">
        <table
          className={`table-fixed w-full min-w-[720px] ${
            props.tableClassName || ""
          }`}
        >
          {props.children}
        </table>
      </div>
    </div>
  );
};

export default StyledTable;
